import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1db3dd9a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/confirm-recaptcha/_confirm-recaptcha.scss?vue&type=style&index=0&id=1db3dd9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db3dd9a",
  null
  
)

export default component.exports